






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mixin as clickaway } from 'vue-clickaway';
import ConditionGroupBuilder, { ConditionGroupUpdate } from '@/shared/components/conditions/ConditionGroupBuilder.vue';
import { validationMixin } from 'vuelidate';
import TagBox from '@/shared/components/TagBox.vue';
import TransitionPicker from '@/features/bots/components/designer/TransitionPicker.vue';
import DragIcon from '@/shared/components/DragIcon.vue';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import { DecisionViewModel } from '@/features/bots/models/designer/decisionViewModel';
import { DecisionConditionsAttributeType, DecisionConditionsManager } from '@/features/bots/components/designer/Conditions/decisionConditionsManager';
import { required, minLength } from 'vuelidate/lib/validators';
import { InputVariableViewModel } from '../../models/designer';
import { Getter } from 'vuex-class';
import { ConditionDataType, ConditionPickerOption } from '@/shared/components/conditions/models/conditions';

@Component({
	mixins: [
		clickaway,
		validationMixin
	],
	validations: {
	  providedDecision: {
			conditions: {
				conditions: {
					required,
					minLength: minLength(1),
					conditionValid() {
						const decision = (this as any);
						const invalidCondition: boolean = decision.isInvalidCondition;
						return !invalidCondition;
					}
				},
			},
			transition: {
				required,
				type: {
					required
				},
				payload: {
					payloadValid(payload: string) {
						const component = (this as any);
						if (payload) {
							return !component.isTransitionPayloadInvalid(payload);
						}
						return true;
					}
				}
			}
		}
	},
	components: {
		ConditionGroupBuilder,
		TagBox,
		TransitionPicker,
		DragIcon
	}
})
export default class Decision extends Vue {
	@Prop() public decision: DecisionViewModel;
	@Prop() public canDelete: boolean;
	@Getter public flowVariables: InputVariableViewModel[];
	@Getter public isTransitionPayloadInvalid: (payload: string) => boolean;
	public isInvalidCondition: boolean = false;
	public decisionConditionsManager: DecisionConditionsManager = new DecisionConditionsManager();

	public providedDecision = {
		conditions: {
			type: 'and',
			conditions: []
		},
		transition: {
			payload: undefined,
			type: undefined
		}
	} as DecisionViewModel;

	public mounted() {
		this.providedDecision = this.decision;
		this.checkValidTransition();
		this.setUpConditions();
	}

	@Watch('flowVariables', { immediate: true, deep: true })
	public onFlowVariablesChanged() {
		this.setUpConditions();
		this.providedDecision = JSON.parse(JSON.stringify(this.providedDecision));
	}

	public conditionUpdated(update: ConditionGroupUpdate) {
		this.isInvalidCondition = update.invalid;
		const clone = JSON.parse(JSON.stringify(this.providedDecision)); // to prevent updating the providedDecision which would kick off processing in child
		clone.conditions = update.conditionGroup;
		this.$emit('updated', clone, this.$v.providedDecision.$invalid);
	}

	public deleteDecision() {
		this.$emit('deleted');
	}

	public transitionSelected(transition: TransitionViewModel) {
		this.providedDecision.transition = transition;
		this.$emit('updated', this.providedDecision, this.$v.providedDecision.$invalid);
	}

	private checkValidTransition() {
		if (!this.providedDecision.transition) {
			this.$v.providedDecision.transition!.$touch();
			this.$nextTick(() => this.$emit('updated', this.providedDecision, this.$v.providedDecision.$invalid));
		}
	}

	private setUpConditions() {
		this.decisionConditionsManager.setContextualConditions([
			...this.flowVariables.map((flowVar) => {
				return {
					id: `flow.${flowVar.name}`,
					title: flowVar.name,
					type: ConditionDataType.Text,
					icon: 'FlowVariableIcon'
				} as ConditionPickerOption;
			}),
			{
				id: DecisionConditionsAttributeType.TimeOfDay,
				title: 'Time of day',
				type: ConditionDataType.DateTime,
				icon: 'DurationIcon'
			}
		]);
	}
}
